import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { ContactForm } from 'components/ContactForm'
import { sendMessage, resetFormMsg } from 'redux/actions/contacts'

class ContactFormContainer extends Component {
	componentWillUnmount() {
		const { dispatch } = this.props
		dispatch(resetFormMsg())
	}
	render () {
		return <ContactForm {...this.props}/>
	}
}
const mapStateToProps = state => {
	return {
		message: state.contactForm.successMsg
	}
}
const mapDispatchToProps = dispatch => {
	return {
		onSubmit: data => {
			return dispatch(sendMessage(data))
		}
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(reduxForm({ form: 'contactForm' })(ContactFormContainer))
